// Small colour-coded pill showing where a record came from.
// Values match the backend `DataSource` enum:
//   dev    — grey/slate  (system seed / test data)
//   mongo  — normal      (imported from real JSON exports / webhooks)
//   manual — blue        (user-created in the UI)
//
// Rendered as a tiny dot with an accessible title tooltip. Use inline in
// tables where a full badge would be too heavy. Colour palette lives in
// /app/frontend/src/constants/pipeline.js so it stays in sync with the
// filter chips and any other data-source surface.
import { SOURCE_TONE } from "../../constants/pipeline";

export { SOURCE_TONE };

export function SourceDot({ value, size = "sm" }) {
  const src = value === "dev" || value === "manual" ? value : "mongo";
  const tone = SOURCE_TONE[src];
  const dim = size === "xs" ? "w-1.5 h-1.5" : "w-2 h-2";
  return (
    <span
      className={`inline-block rounded-full ring-2 ring-offset-0 ${tone.dot} ${tone.ring} ${dim}`}
      title={tone.label}
      data-testid={`source-dot-${src}`}
    />
  );
}

export function SourceChip({ value }) {
  const src = value === "dev" || value === "manual" ? value : "mongo";
  const tone = SOURCE_TONE[src];
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded border font-mono uppercase tracking-widest text-[9px] ${tone.text} border-white/10 bg-white/[0.03]`}
      title={tone.label}
      data-testid={`source-chip-${src}`}
    >
      <span className={`inline-block w-1.5 h-1.5 rounded-full ${tone.dot}`} />
      {src}
    </span>
  );
}
